import { render, staticRenderFns } from "./BatchesPage.vue?vue&type=template&id=66dd3ad4"
import script from "./BatchesPage.vue?vue&type=script&lang=js"
export * from "./BatchesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports